import type { enSkills } from "./en-skills.ts";

export const ptBRSkills: Record<keyof typeof enSkills, string> = {
  "skills.title": "Skills",
  "skills.subtitle": "Diretrizes de domínio, procedimentos e pacotes de ferramentas especializadas.",
  "skills.import": "Importar Skill",
  "skills.searchPlaceholder": "Buscar skills...",
  "skills.scope": "Escopo:",
  "skills.allScopes": "Todos os escopos",
  "skills.platform": "Plataforma",
  "skills.organization": "Organização",
  "skills.project": "Projeto",
  "skills.loading": "Carregando skills...",
  "skills.failed": "Falha ao carregar skills.",
  "skills.colName": "Nome",
  "skills.colDescription": "Descrição",
  "skills.colScope": "Escopo",
  "skills.colStatus": "Estado",
  "skills.colActions": "Ações",
  "skills.details": "Detalhes",
  "skills.export": "Exportar",
  "skills.empty": "Nenhuma skill encontrada. Importe um pacote SKILL.md para começar.",
  "skills.version": "Versão",
  "skills.hash": "Hash",
  "skills.created": "Criada em",
  "skills.instructions": "Instruções (SKILL.md)",
  "skills.assets": "Recursos",
  "skills.bytes": "bytes",
  "skills.noActiveVersion": "Nenhuma versão ativa publicada para esta skill.",
  "skills.close": "Fechar",
  "skills.importTitle": "Importar pacote SKILL.md",
  "skills.platformGlobal": "Plataforma (Global)",
  "skills.contentLabel": "Conteúdo do SKILL.md",
  "skills.cancel": "Cancelar",
  "skills.importing": "Importando...",
  "skills.placeholderSkillMd": "Cole o conteúdo do SKILL.md com frontmatter YAML",
};
